<template>
  <Icon-Template :size="size">
    <svg viewBox="0 0 12 13" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.0371 7.92249C10.3024 7.92249 9.58104 7.80854 8.89745 7.58452C8.56248 7.47122 8.1507 7.57516 7.94626 7.78338L6.59698 8.79347C5.03221 7.96514 4.06833 7.00959 3.24446 5.46949L4.23305 4.1663C4.48989 3.91193 4.58202 3.54036 4.47164 3.19173C4.24477 2.51026 4.12952 1.79523 4.12952 1.06634C4.12955 0.539794 3.69758 0.11142 3.16665 0.11142H0.962904C0.431968 0.11142 0 0.539794 0 1.06631C0 7.1016 4.95117 12.0116 11.0371 12.0116C11.568 12.0116 12 11.5832 12 11.0567V8.87736C12 8.35087 11.568 7.92249 11.0371 7.92249Z"/>
    </svg>
  </Icon-Template>
</template>

<script>

import IconTemplate from '@/components/icons/Template'

export default {
  props: ['size'],
  components: { IconTemplate }
}
</script>